import Vue from 'vue'
import Vuex from 'vuex'
import staticData from '@api/staticData'

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        isLogged: false,
        user: null,
        listaEstados: [],
        optionsRelatorioOrcamentoGn: {
            itemsPerPage: '15',
            search: "",
            withValue: true,
            withEspelho: false,
        }
    },
    getters: {
        isAdmin(state) {
            return state.user.admin;
        },
        canAuthorizeImplantacaoSuperior(state) {
            return state.user.funcionario.perfil.permissoesList
                .includes('autorizar_implantacao_superior');
        },
        canAuthorizarDiretoria(state) {
            return state.user.funcionario.perfil.permissoesList
                .includes('autorizar_diretoria');
        },
        canAuthorizeImplantacao(state) {
            return state.user.funcionario.perfil.permissoesList
                .includes('autorizar_implantacao');
        },
        canAuthorizeFinanceiro(state) {
            return state.user.funcionario.perfil.permissoesList
                .includes('autorizar_financeiro');
        },
        canFinalizeObra(state) {
            return state.user.funcionario.perfil.permissoesList
                .includes('finalizar_obra');
        },
        canCreateOrderPayment(state) {
            return state.user.funcionario.perfil.permissoesList
                .includes('criar_ordem_pagamento');
        },
        canDeleteOrderPayment(state) {
            return state.user.funcionario.perfil.permissoesList
                .includes('excluir_ordem_pagamento');
        },
        canAuthorizeFinanceiroSuperior(state) {
            return state.user.funcionario.perfil.permissoesList
                .includes('autorizar_financeiro_superior');
        },
    },
    mutations: {
        isLogged(state, payload) {
            state.isLogged = payload
        },
        setUser(state, payload) {
            state.user = payload
        },
        setListaEstados(state, payload) {
            state.listaEstados = payload
        },
        setOptionsRelatorioOrcamentoGn(state, payload) {
            state.optionsRelatorioOrcamentoGn = payload
        },
    },
    actions: {
        async loadStaticData({ commit }) {

            const listaStaticData = await staticData.getAll()
            commit('setListaEstados', listaStaticData.data.estados)

        }
    },
})

export default store
